import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subject} from "rxjs";
import { takeUntil } from 'rxjs/operators';
import { BreadCrumbService } from '../../providers/breadcrumb/breadcrumb.service';
import { NavigationProvider, INavigationItem } from '@nrwl/navigation-abstract';

@Component({
  selector: 'nrwl-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadCrumbComponent implements OnInit, OnDestroy {
  breadCrumbs$: Observable<Array<INavigationItem>>;
  private readonly unsubscribe: Subject<void> = new Subject();
  private breadCrumbList: INavigationItem[];

  constructor(
    private readonly breadCrumbService: BreadCrumbService,
    private readonly navigator: NavigationProvider
  ) { }

  ngOnInit() {
    this.breadCrumbs$ = this.breadCrumbService.breadCrumbs$;
    this._subcribeHandler();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  _subcribeHandler() {
    this.breadCrumbService.breadCrumbs$.pipe(
      takeUntil(this.unsubscribe))
      .subscribe((breadCrumbs:INavigationItem[]) => {
        this.breadCrumbList = breadCrumbs;
      });
  }

  onClick(breadCrumb:INavigationItem) {
    if (breadCrumb.outlet) {
      this.navigator.navigateByOutletParams(breadCrumb);
      return;
    }
    else if (breadCrumb.type) {
      this.navigator.navigateByType(breadCrumb);
    }
    else {
      // default to using browser back state based on index of breadcrumb item chosen
      for (let index=0; index < this.breadCrumbList.length; index++) {
        if (this.breadCrumbList[index].label === breadCrumb.label) {
          window.history.go((this.breadCrumbList.length - 1 - index) * -1);
          break;
        }
      }
    }
  }

}
